export default "/assets/images/home-wrecker-crop1.ac7a92301022d3d7.webp";